@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/color/license-plate" as license_plate;

web-license-plate {
    --badge-background-color: #{license_plate.$color-background-license-plate-eu};
    --badge-text-color:  #{license_plate.$color-text-license-plate-eu};

    --input-background-color: #{color.$color-white};
    --input-text-color: #{color.$color-text-lighter};

    --border-color: #{color.$color-border};
    --border-focus-color: #{color.$color-primary-darker};
    --border-width: #{border-width.$sm};
    --border-radius: #{border-radius.$lg};

    display: block;

    .web-license-plate-container {
        display: flex;
        border: var(--border-width) solid var(--border-color);
        border-radius: var(--border-radius);
        background: var(--input-background-color);
        transition: border-color 0.15s linear;

        &:focus,
        &:focus-within {
            border-color: var(--border-focus-color);
        }

        input[type="text"] {
            flex: 1 1;
            appearance: none;
            padding: spacing.$md spacing.$md-lg spacing.$sm;
            background: transparent;
            color: var(--input-text-color);
            border: none;
            border-radius: var(--border-radius);
            outline: none;
            text-transform: uppercase;
            min-width: 0;

            &::placeholder {
                color: color.$color-placeholder;
                text-transform: none;
            }
        }

        .country-code {
            padding: spacing.$sm spacing.$md;
            color: var(--badge-text-color);
            background: var(--badge-background-color);
            border-radius: var(--border-radius) 0 0 var(--border-radius);

            web-icon {
                width: size.$icon-sm;
                height: size.$icon-sm;
                margin: 0 auto;
            }

            .label {
                display: block;
                margin-top: calc(#{spacing.$sm} - 1px);
                text-align: center;
                text-transform: uppercase;
                font-family: font-family.$primary-bold;
                font-size: font-size.$xxxxs;
                line-height: font-size.$xxxxs;
            }
        }
    }
}
